// Dependencies
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AddToMailchimp from 'gatsby-plugin-mailchimp';
import parse from 'html-react-parser';

// Components
import InputFactory from '../../forms/inputFactory/inputFactory';

// Hooks
import useNewsletterFormOptions from '../../../hooks/useNewsletterFormOptions';

// Styles
import NewsletterFormStyles from './newsletterForm.styles';

// Images
import newsletterImg from '../../../img/newsletter.jpg';

export default function NewsletterForm({ page, blog }) {
  const [formData, setFormData] = useState({
    email: '',
  });

  const [formError, setFormError] = useState(null);
  const [formSuccess, setFormSuccess] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  const handleChange = (event, actionMeta) => {
    const { value } = event?.target || event;
    const { name } = event?.target || actionMeta || '';

    setFormData((fields) => ({
      ...fields,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    setFormLoading(true);
    setFormError(null);
    setFormSuccess(false);

    AddToMailchimp(formData?.email).then((response) => {
      setFormLoading(false);

      if (response?.result === 'success') {
        setFormSuccess(true);
      } else {
        setFormError('Error, please try again later.');
        setFormSuccess(false);
      }
    });
  };

  const options = useNewsletterFormOptions();
  const heading = options?.newsletterFormHeading;
  const text = options?.newsletterFormText || '';
  const submitText = options?.newsletterFormSubmitButtonText;

  return (
    <NewsletterFormStyles page={page} blog={blog}>
      {!!blog && (
        <img src={newsletterImg} alt="Decorative banner" className="bg" />
      )}

      <div className={`inner ${!!blog && 'blog'}`}>
        <h4 className="heading">{heading}</h4>
        {!formSuccess && parse(text)}
        <form onSubmit={handleSubmit}>
          {!formSuccess && (
            <InputFactory
              type="email"
              name="email"
              placeholder="Email address"
              onChange={handleChange}
              disabled={formLoading}
              required
              error={formError}
              value={formData?.email}
            />
          )}

          {formSuccess && (
            <div className="form-success">
              <p>We need to confirm your email address.</p>
              <p>
                To complete the subscription process, please click the link in
                the email we just sent you.
              </p>
            </div>
          )}

          {!formSuccess && (
            <button
              type="submit"
              disabled={formLoading}
              className={`btn dark ${!blog && 'full-width'}`}
            >
              {submitText}
            </button>
          )}
        </form>
      </div>
    </NewsletterFormStyles>
  );
}

NewsletterForm.propTypes = {
  page: PropTypes.bool,
  blog: PropTypes.bool,
};

NewsletterForm.defaultProps = {
  page: false,
  blog: false,
};
